<div floori-dialog-header>
    {{ headerTranslationKey | flTranslate }}
</div>
<section floori-dialog-content>
    @if (langs.length) {
    <div floori-radio-group [(ngModel)]="currentLang">
        @for (lang of langs; track lang.code) {
        <floori-radio [value]="lang.code">
            <img [src]="lang.flag" [alt]="lang.code" loading="lazy" />
            <span>{{ (lang.language | flTranslate) || lang.code }}</span>
        </floori-radio>
        }
    </div>
    }
</section>
<div floori-dialog-actions>
    <button class="floori-button primary big" [floori-dialog-close]="currentLang">
        {{ selectTranslationKey | flTranslate }}
    </button>
</div>
